import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton
} from '@mui/material';
import {
  Close as CloseIcon,
  Download as DownloadIcon,
  QrCode as QrCodeIcon
} from '@mui/icons-material';
import EventQRCode from './EventQRCode';

interface QRCodeModalProps {
  open: boolean;
  onClose: () => void;
  eventId: string;
  organizationId: string;
  eventTitle: string;
}

const QRCodeModal: React.FC<QRCodeModalProps> = ({
  open,
  onClose,
  eventId,
  organizationId,
  eventTitle
}) => {
  const handleDownload = () => {
    const canvas = document.querySelector('#event-qr-code canvas') as HTMLCanvasElement;
    if (!canvas) return;

    // Create a temporary link element
    const link = document.createElement('a');
    link.download = `${eventTitle.toLowerCase().replace(/\s+/g, '-')}-qr-code.png`;
    link.href = canvas.toDataURL('image/png');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <QrCodeIcon />
            <Typography>Event QR Code</Typography>
          </Box>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <Box 
          id="event-qr-code"
          sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            gap: 2,
            p: 3
          }}
        >
          <EventQRCode
            eventId={eventId}
            organizationId={organizationId}
            size={300}
            includeMargin={true}
          />
          <Typography variant="body2" color="text.secondary" align="center">
            Scan this QR code to access the event page
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button
          startIcon={<DownloadIcon />}
          variant="contained"
          onClick={handleDownload}
        >
          Download QR Code
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QRCodeModal; 